import axios from '../utils/axiosClient';
import endpoints from './endpoints';

const { getTickets, editTicket, createTicket, deleteTicket, getTicketFile } = endpoints;

const fetchTickets = async (params: any) => {
  try {
    const response = await axios.get(getTickets, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const updateTicket = async (id: string, formData: any) => {
  try {
    const response = await axios.put(editTicket(id), formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const saveTicket = async (formData: any) => {
  try {
    const response = await axios.post(createTicket, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const deleteDraft = async (id: string) => {
  try {
    const response = await axios.delete(deleteTicket(id));
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const fetchTicketFile = async (id: string, params: any) => {
  try {
    const response = await axios.get(getTicketFile(id), { params, responseType: 'blob' });
    const fileBlob = new Blob([response.data], { type: response.headers['content-type'] });
    return URL.createObjectURL(fileBlob);
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const ticketsServices = { fetchTickets, saveTicket, updateTicket, deleteDraft, fetchTicketFile };

export default ticketsServices;
